import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.div`
  padding: 1.5rem;
  background: ${theme.colors.mainBg};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: ${theme.border.smallRadius};

  display: flex;
  gap: 18px;
  flex-direction: column;
`

export const Title = styled.h2`
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.semiBold};
  font-size: 1.25rem;
  line-height: 1.5rem;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: ${theme.colors.blackLight};
`

export const Table = styled.div`
  width: 95%;
  align-self: flex-end;
`

export const THeader = styled.div`
  margin-bottom: 8px;
  width: 100%;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
`

export const HeaderCell = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.02em;
  color: #929BA8;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const TRow = styled.div`
  width: 100%;
  height: 49px;

  position: relative;

  display: grid;
  grid-template-columns: repeat(3, 1fr);

  background: ${theme.colors.secondLightGray};
  border-radius: .25rem;
`

export const Index = styled.span`
  height: 49px;
  position: absolute;
  left: -5%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #DF5605;
`

export const Cell = styled.p`
  text-align: center;
  padding: 10px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.02em;
  color: #8B8B8B;

  display: flex;
  align-items: center;
  justify-content: center;
`
